import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';
import { ISummaryReport } from '../../../utils/interfaces/summary-report';

@Injectable({
  providedIn: 'root',
})
export class SummaryReportService {
  private readonly URI_API = environment.apiConfig.uri + 'ConsolidatedReport';

  constructor(private readonly httpClient: HttpClient) {}

  getSummaryReport(
    filter: IReportFilter
  ): Observable<IResponse<ISummaryReport>> {
    return this.httpClient
      .post<IResponse<ISummaryReport>>(`${this.URI_API}/consolidated`, filter)
      .pipe(
        map((res): IResponse<ISummaryReport> => {
          res.data.pages.sort((a, b) => a.pageNumber - b.pageNumber);
          return res;
        })
      );
  }
}
